import { useQuery } from '@tanstack/react-query';

import { Groups } from '@app/client';

import { useGroupId } from './useGroupId';
import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query to call `/groups/:groupId/member/can_moderate`.
 */
export const useGetModerationPermission = (defaultGroupId?: string) => {
    // We don't have to use ?? operator here because that operator doesn't handle empty string cases
    const groupId = useGroupId() || defaultGroupId;

    return useQuery(groupsCacheKeys.canModerate(groupId), () => Groups.callCanModerate({ groupId }), {
        retry: false,
        enabled: Boolean(groupId),
    });
};
